// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BuyersDeal_wrapper__UxCsi","titleWrapper":"BuyersDeal_titleWrapper__TKYYn","dot":"BuyersDeal_dot__VywSf"};